import React from 'react'
const DottedLineArrow = () =>(
<svg xmlns="http://www.w3.org/2000/svg" width="10" height="22.031" viewBox="0 0 10 22.031">
  <path id="Union_16" data-name="Union 16" d="M0,17.236l1.666-1.6,2.223,2.13V7.663H6.113v10.1l2.217-2.13L10,17.236,5,22.03ZM3.9,5.745V3.831H6.1V5.745Zm0-3.827V0H6.1V1.917Z" transform="translate(-0.002 0.001)" fill="#529a00"/>
  </svg>
)
export default DottedLineArrow
